import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";

import solutionsListSliceReducer from "@modules/Solution/SolutionsList/SolutionsList.slice";
import transportQuotationsSliceReducer from "@modules/TransportQuotations/TransportQuotationsList/TransportQuotations.slice";
import analyticalNotesListSliceReducer from "@modules/AnalyticalNotes/AnalyticalNotesList/AnalyticalNotesList.slice";
import meetingReportsListSliceReducer from "@modules/MeetingReports/MeetingReportsList/MeetingReportsList.slice";
import contactListSliceReducer from "@modules/Contact/ContactList/ContactList.slice";
import relatedContactListSliceReducer from "@modules/RelatedContact/RelatedContactList/RelatedContactList.slice";
import productsListSliceReducer from "@modules/Products/ProductsList/ProductsList.slice";
import centerListSliceReducer from "@modules/Center/CenterList/CenterList.slice";
import centerProductsListSliceReducer from "@modules/CenterProducts/CenterProductsList/CenterProductsList.slice";
import priceListReducer from "@modules/CenterProductPrice/PriceList/PriceList.slice";
import sharedSliceReducer from "@shared/shared.slice";
import companyListSliceReducer from "@modules/Company/CompanyList/CompanyList.slice";
import warehouseListSliceReducer from "@modules/Warehouse/WarehouseList/WarehouseList.slice";
import siteListSliceReducer from "@modules/Site/SiteList/SiteList.slice";
import enquiryListSliceReducer from "@modules/Enquiry/EnquiryList/EnquiryList.slice";
import sellingPricesListSliceReducer from "@modules/SellingPrice/SellingPricesList/SellingPricesList.slice";
import quoteListSliceReducer from "@modules/Quote/QuoteList/QuoteList.slice";
import leadListSliceReducer from "@modules/Lead/LeadList/LeadList.slice";
import sagas from "./rootSaga";

const logger = createLogger({
  predicate: () => process.env.NODE_ENV === "development",
});

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(logger, sagaMiddleware),
  reducer: {
    general: sharedSliceReducer,
    solutionsList: solutionsListSliceReducer,
    transportQuotations: transportQuotationsSliceReducer,
    analyticalNotesList: analyticalNotesListSliceReducer,
    meetingReportsList: meetingReportsListSliceReducer,
    contactList: contactListSliceReducer,
    relatedContactList: relatedContactListSliceReducer,
    productsList: productsListSliceReducer,
    centerList: centerListSliceReducer,
    centerProductsList: centerProductsListSliceReducer,
    centerProductPriceList: priceListReducer,
    companyList: companyListSliceReducer,
    warehouseList: warehouseListSliceReducer,
    siteList: siteListSliceReducer,
    enquiryList: enquiryListSliceReducer,
    sellingPricesList: sellingPricesListSliceReducer,
    quoteList: quoteListSliceReducer,
    leadList: leadListSliceReducer,
  },
});
sagaMiddleware.run(sagas);

export default store;
